<template>
	<guest-template :showNavFooter="false" :showNavHeader="true">
		<v-container
			class="details-view pa-0"
			style="max-width: 1185px !important"
		>
			<SearchDetails
				:showForm="false"
				:uuid="uuid"
				breakpoint="xs"
				@submit="onSubmit"
			/>
			<v-overlay :value="isLoading">
				<v-progress-circular
					indeterminate
					size="64"
				></v-progress-circular>
			</v-overlay>
			<v-overlay :value="showErrorModal()">
				<v-card
					class="mx-auto"
					max-width="512"
					light
					v-if="showErrorModal()"
				>
					<v-card-title>Uh Oh!</v-card-title>
					<v-card-text>{{ error ? error.message : '' }}</v-card-text>
					<v-card-actions>
						<v-btn color="primary" @click="hideModal()">
							Close
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-overlay>
		</v-container>
	</guest-template>
</template>

<script>
import guestTemplate from '../../templates/guestTemplate.vue'
import { mapActions } from 'vuex'
import { getUrlParams } from '../../utilities'

export default {
	components: { guestTemplate },
	name: 'DetailsView',

	data() {
		return {
			uuid: this.$route.params.uuid,
			isLoading: false,
			error: null,
			urlParams: {}
		}
	},
	methods: {
		...mapActions(['register']),

		onSubmit(user) {
			this.isLoading = true
			for (var param in this.urlParams) {
				user[param] = this.urlParams[param]
			}
			this.register({ ...user, institution: this.uuid })
				.then((data) => {
					this.isLoading = false
					if (window.analytics) {
						window.analytics.track('search_register', {
							organization_id: this.uuid
						})
					}
					if (data.has_institution) {
						this.navigate(
							{
								name: 'mindonation',
								params: { onboarding: true }
							},
							'right'
						)
					} else {
						this.navigate(
							{
								name: 'institutions',
								params: { onboarding: true }
							},
							'right'
						)
					}
				})
				.catch((e) => {
					this.isLoading = false
					this.error = e.response.message
				})
		},
		showErrorModal() {
			return this.error && this.error.message
		},
		hideModal() {
			this.error = null
		}
	},
	mounted() {
		const urlParams = getUrlParams(window.location.href)
		if (urlParams) {
			for (var param in urlParams) {
				if (param !== 'email') {
					this.urlParams[param] = decodeURIComponent(urlParams[param])
				}
			}
		}
	}
}
</script>
<style lang="scss" scoped>
@import '../../styles/typography-screen';

.details-view {
	background-color: $white;
	padding-top: 42px;

	p {
		margin-bottom: 16px !important;
	}
	h3 {
		font-size: 1.25rem !important;
		font-family: 'Work Sans' !important;
		font-weight: 600 !important;
		line-height: normal !important;
	}
}

.details-view::v-deep .detail-view-body {
	padding: 0px 24px;
	> div {
		padding-left: 0px !important;
		padding-right: 0px !important;
	}
}

.details-view::v-deep .v-footer {
	z-index: 20;
}
</style>
